<template>
  <div class="notfound-container" @click="logout">
    <el-card class="notfound-card">
      <img src="~@/assets/shield_black.svg" />
      <h3>Page Not Found</h3>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Notfound",
  props: {},
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.commit("user/logout");
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped lang="scss">
.notfound-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;

  .notfound-card {
    max-width: 100%;
    text-align: center;
  }
  @media only screen and (max-width: $sm) {
    .notfound-card {
      width: 80%;
    }
  }
}
</style>
